/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportType } from './ReportType';
import { ReportTypeFromJSON, ReportTypeFromJSONTyped, ReportTypeToJSON } from './ReportType';

/**
 *
 * @export
 * @interface PaginatedReportTypeList
 */
export interface PaginatedReportTypeList {
  /**
   *
   * @type {number}
   * @memberof PaginatedReportTypeList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedReportTypeList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedReportTypeList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ReportType>}
   * @memberof PaginatedReportTypeList
   */
  results: Array<ReportType>;
}

/**
 * Check if a given object implements the PaginatedReportTypeList interface.
 */
export function instanceOfPaginatedReportTypeList(value: object): value is PaginatedReportTypeList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedReportTypeListFromJSON(json: any): PaginatedReportTypeList {
  return PaginatedReportTypeListFromJSONTyped(json, false);
}

export function PaginatedReportTypeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedReportTypeList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ReportTypeFromJSON),
  };
}

export function PaginatedReportTypeListToJSON(value?: PaginatedReportTypeList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ReportTypeToJSON),
  };
}
